import {
  all,
  call,
  put,
  select,
} from 'redux-saga/effects';

import { getField } from '../fieldSaga';
import { getHarvestSeasons } from '../harvestSaga';
import { getMosaicData } from '../mosaicSaga';
import { getPrecPlantingSeasons } from '../precisionPlantingSaga';
import { getProductAssets } from '../productAssetsSaga';
import { receiveUserDetails, reqUserDetails } from '../../actions/userActions';
import { retrievePlantingData } from './retrievePlantingData';
import { getCropMap } from '../cropSaga';


/**
 * Calls the getField saga and getHarvestSeasons saga synchronously
 * @param {String} fieldId - either Field Legacy Id or Field UUID
 * @return {void}
 */
export function* fieldDeps(fieldId) {
  // Get field info used for the following API calls
  const { fieldUUID, fieldLegacyId, fieldOwnerId } = yield call(getField, fieldId);

  const state = yield select();
  const currentUserId = state.currentUser.clientId;
  const { isProxying } = state.user;

  if (!isProxying) {
    if (currentUserId === fieldOwnerId) {
      yield put(receiveUserDetails(state.currentUser, false));
    } else {
      yield put(reqUserDetails(fieldOwnerId));
    }
  }

  const cropsMap = yield call(getCropMap);
  const callSteps = [
    call(getProductAssets, fieldUUID, isProxying ? fieldOwnerId : undefined),
    call(getMosaicData, fieldLegacyId, fieldOwnerId),
    call(getPrecPlantingSeasons, fieldUUID),
    call(getHarvestSeasons, fieldUUID, fieldOwnerId),
    call(retrievePlantingData, {fieldUUID, cropsMap})
  ];

  const [
    productAssets,
    mosaicData,
    precPlantingSeasons,
    harvestSeasons,
    plantingEvents,
  ] = yield all(callSteps);

  return {
    harvestSeasons,
    mosaicData,
    precPlantingSeasons,
    productAssets,
    plantingEvents,
  };
}